import React from "react";
import Select from "react-select";
import './index.scss';

const COLOR_BY_OPTIONS = [
  { value: "levels", label: "Levels" },
  { value: "teachers", label: "Teachers" },
  { value: "styles", label: "Styles" },
];

const ColorBySelect = ({ propColorBy, handleColorByChange }) => {
  return (
    <div className="d-flex align-items-center ms-2">
      <span
        className="me-2 fw-semibold text-nowrap"
        style={{ fontSize: "14px", color: "#3F3F55" }}
      >
        Color by:
      </span>
      <Select
        className="colorBySelect my-1"
        classNamePrefix="colorBySelect"
        value={COLOR_BY_OPTIONS.find((option) => option.value === propColorBy)}
        onChange={handleColorByChange}
        options={COLOR_BY_OPTIONS}
        placeholder="Select option"
      />
    </div>
  );
};
export default ColorBySelect;
